import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { id: "Overview" }
const _hoisted_2 = { class: "OverviewTabsWrapper" }
const _hoisted_3 = { class: "OverviewTabContent" }
const _hoisted_4 = { class: "ConfigurationBlockList WhiteBackground" }
const _hoisted_5 = { class: "EntityTypeBlock" }
const _hoisted_6 = { class: "ConfigurationBlockOptionEntityDetails" }
const _hoisted_7 = { class: "ConfigurationBlockOptionId" }
const _hoisted_8 = { class: "OverviewTabContent" }
const _hoisted_9 = {
  key: 0,
  class: "SelectionDetailsWarningMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountryTargetingSummary = _resolveComponent("CountryTargetingSummary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", {
        class: _normalizeClass([
				'OverviewTab',
				_ctx.selectedOverallTab === 0 ? 'Selected' : ''
			])
      }, [
        _createElementVNode("div", {
          class: "OverviewTabHeader",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleOverallTab(0)))
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "OverviewTabHeaderTitle" }, " Selected Entities ", -1 /* CACHED */)),
          _createTextVNode(" (" + _toDisplayString(_ctx.selectedEntitiesDetails) + ") ", 1 /* TEXT */),
          _cache[4] || (_cache[4] = _createElementVNode("i", { class: "lnr-chevron-right OverviewTabChevron" }, null, -1 /* CACHED */))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailsOfSelectedEntities, (detailsOfEntity) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "ConfigurationBlockOption",
                key: detailsOfEntity.id
              }, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.retrieveEntityType(detailsOfEntity)), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_6, [
                  (_ctx.isEntityTypeStudy(detailsOfEntity))
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass([
										'EntityTypeLabel',
										detailsOfEntity.degreeType
									])
                      }, _toDisplayString(detailsOfEntity.degreeName) + " ", 3 /* TEXT, CLASS */))
                    : _createCommentVNode("v-if", true),
                  _createTextVNode(_toDisplayString(detailsOfEntity.title) + " (", 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(detailsOfEntity.id), 1 /* TEXT */),
                  _cache[5] || (_cache[5] = _createTextVNode(") ", -1 /* CACHED */))
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ], 2 /* CLASS */),
      _createVNode(_component_CountryTargetingSummary, {
        id: 1,
        tabSelected: _ctx.selectedOverallTab === 1,
        numCountriesPerPremium: _ctx.numCountriesPerPremium,
        countriesPerPremium: _ctx.countriesPerPremium,
        pricing: null,
        onTabSelectionChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleOverallTab(1)))
      }, null, 8 /* PROPS */, ["tabSelected", "numCountriesPerPremium", "countriesPerPremium"]),
      _createElementVNode("section", {
        class: _normalizeClass([
				'OverviewTab',
				_ctx.selectedOverallTab === 2 ? 'Selected' : ''
			])
      }, [
        _createElementVNode("div", {
          class: "OverviewTabHeader",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleOverallTab(2)))
        }, [
          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "OverviewTabHeaderTitle" }, " Pricing ", -1 /* CACHED */)),
          _createTextVNode(" (" + _toDisplayString(_ctx.pricingDetails) + ") ", 1 /* TEXT */),
          _cache[7] || (_cache[7] = _createElementVNode("i", { class: "lnr-chevron-right OverviewTabChevron" }, null, -1 /* CACHED */))
        ]),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.pricingDescription), 1 /* TEXT */)
      ], 2 /* CLASS */)
    ]),
    _cache[9] || (_cache[9] = _createElementVNode("hr", { class: "VerticalLine" }, null, -1 /* CACHED */)),
    (!_ctx.doSelectedEntitiesHaveTheSameConfiguration)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[8] || (_cache[8] = [
          _createElementVNode("i", { class: "lnr-warning SelectionWarningIcon" }, null, -1 /* CACHED */),
          _createElementVNode("span", null, " If these settings are saved, the existing configuration, which is different for the selected organisations and studies, will be overwritten. ", -1 /* CACHED */)
        ]))]))
      : _createCommentVNode("v-if", true)
  ]))
}